import { faBell } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { StatCard } from "./StatCard";
import { useHseSummary } from "@dashboard/hooks/useHseSummary";

export default function AttentionTasks() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref = summary && !Array.isArray(summary.links) ? summary.links.tasks : undefined;

    return (
        <StatCard
            label={t("dashboard.tasksNeedAttention")}
            value={summary?.metrics.tasks.needsAttention}
            isPending={isPending}
            isError={isError}
            icon={faBell}
            variant="pink"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageTasks")}
        />
    );
}
